import { cloneDeep } from 'lodash';

export class PropModel {
  get _props(): Record<string, unknown> {
    const props: Record<string, unknown> = {};
    Object.getOwnPropertyNames(this).map(
      (prop: string) => (props[prop] = this[prop as keyof this])
    );
    return cloneDeep(props);
  }
}
